import { useQuery } from '@tanstack/react-query';
import { isApiError } from '@/shared/lib/apiClient';
import {
  SUBSCRIPTION_EVENT_QUERY_KEYS,
  SUBSCRIPTION_EVENT_REFETCH_INTERVAL_MS,
} from '../constants';
import { fetchSubscriptionEventHistory } from '../services/subscriptionEvents.api';
import type { SubscriptionEventHistoryQuery } from '../types';

function serializeHistoryQuery(
  query: SubscriptionEventHistoryQuery,
): Record<string, string | number> {
  return {
    tenantId: query.tenantId ?? '',
    subscriptionId: query.subscriptionId ?? '',
    productId: query.productId ?? '',
    eventType: query.eventType ?? '',
    eventSource: query.eventSource ?? '',
    limit: query.limit ?? 50,
  };
}

export function useSubscriptionEventHistory(
  query: SubscriptionEventHistoryQuery,
  enabled: boolean,
) {
  const serialized = serializeHistoryQuery(query);

  return useQuery({
    queryKey: SUBSCRIPTION_EVENT_QUERY_KEYS.history(serialized),
    queryFn: ({ signal }) => fetchSubscriptionEventHistory(query, signal),
    enabled,
    staleTime: 15_000,
    refetchInterval: enabled ? SUBSCRIPTION_EVENT_REFETCH_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
    retry: (failureCount, error) => {
      if (isApiError(error) && (error.status === 401 || error.status === 403)) {
        return false;
      }
      return failureCount < 1;
    },
  });
}
